export default __webpack_public_path__ + "static/media/a7f8c6b3ab8b9985.ca30d17c74fc2a65cdf489845a9123e7.svg";